import React, { useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { Route, Routes, Link, useNavigate } from 'react-router-dom';
import VideosPage from './VideosPage'; // To show videos from a channel
import PlaylistsPage from './PlaylistsPage'; // To show playlists
import PlaylistVideosPage from './PlaylistVideosPage';  // Import the component


const App = () => {
  const [token, setToken] = useState('');
  const [channels, setChannels] = useState([]);
  const navigate = useNavigate();

  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      setToken(tokenResponse.access_token);
      await fetchSubscribedChannels(tokenResponse.access_token);
      navigate('/channels');  // Redirect to channels page after successful login
    },
    onError: (error) => console.log('Login Failed:', error),
    scope: 'https://www.googleapis.com/auth/youtube.readonly',
  });

  const fetchSubscribedChannels = async (accessToken) => {
    const response = await axios.get('https://www.googleapis.com/youtube/v3/subscriptions', {
      params: {
        part: 'snippet',
        mine: true,
        maxResults: 50,
      },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const sortedChannels = response.data.items.sort((a, b) =>
      a.snippet.title.localeCompare(b.snippet.title)
    );
    setChannels(sortedChannels);
  };

  return (
    <div className="container">
      <h1 className="text-center my-4">YouTube Subscribed Channels</h1>
      {!token && (
        <button className="btn btn-primary mb-4" onClick={() => login()}>Login with Google</button>
      )}
      
      <Routes>
        <Route path="/" element={<div>Welcome! Please log in to view your subscribed channels.</div>} />
        <Route path="/channels" element={<ChannelsList channels={channels} />} />
        <Route path="/playlists" element={<PlaylistsPage token={token} />} /> {/* New route for playlists */}
        <Route path="/channel/:channelId" element={<VideosPage token={token} />} />
        <Route path="/playlist/:playlistId" element={<PlaylistVideosPage token={token} />} /> {/* New route for playlist videos */}
      </Routes>
    </div>
  );
};

const ChannelsList = ({ channels }) => (
  <div className="row">
    {/* Button aligned to the right with margin on top but no extra margin below */}
    <div className="col-12 d-flex justify-content-end mt-2 mb-3">
      <Link to="/playlists" className="btn btn-secondary">Playlists</Link> {/* Renamed the button */}
    </div>
    {channels.map((channel) => (
      <div className="col-md-3 col-sm-6 mb-4" key={channel.id}>
        <Link to={`/channel/${channel.snippet.resourceId.channelId}`}>
          <div className="card">
            <img
              src={channel.snippet.thumbnails.high.url}
              className="card-img-top"
              alt={channel.snippet.title}
              style={{ width: '50%', height: 'auto', margin: '0 auto' }}
            />
            <div className="card-body">
              <h5 className="card-title text-center">{channel.snippet.title}</h5>
            </div>
          </div>
        </Link>
      </div>
    ))}
  </div>
);

export default App;
